import { validateDate, isFutureDate } from '@Utilities/services/dateTime';
import { useInputState } from './useInputState';

const validations = [
  {
    validate: (value) => !!value,
    errorMessage: 'invalidDateFormat'
  },
  {
    validate: validateDate,
    errorMessage: 'invalidDateFormat'
  }
];

export function useDateInputState(props) {
  const { initialValue, ...useInputStateProps } = props || {};
  return useInputState({
    initialValue: initialValue || null,
    validations,
    ...useInputStateProps
  });
}
